import { LocationManagementLocationType } from "./locationType";

export type AllowedMovement = {
  id: string;
  fromLocationTypeId: string;
  toLocationTypeId: string;
  description?: string;
  fromLocationType?: LocationManagementLocationType;
  toLocationType?: LocationManagementLocationType;
};

export const defaultAllowedMovement: AllowedMovement = {
  id: "",
  fromLocationTypeId: "",
  toLocationTypeId: "",
};
